
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(219|246|373|649)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
